import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgConfetti(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M16.103 30.473L34.27 48.8M6.469 56.39l2.102 2.121a3.028 3.028 0 003.389.631l30.344-13.604c1.954-.876 2.407-3.449.868-4.938L24.24 22.264c-1.505-1.458-4-.983-4.865.925L5.861 53.009a3.028 3.028 0 00.608 3.382z",
      stroke: "#7373FF",
      strokeWidth: 3
    }, void 0), _jsx("path", {
      d: "M26.196 4c5.383 2.206 14.03 8.858 5.552 17.818m11.102 11.2c2.02-5.09 11.608-7.127 15.14 4.582M43.86 6.545l-3.028 5.6",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      d: "M49.484 22.982h6.993M22.263 12.17l4.334 1.987M38 27.5c1.682-5.77 9.5-17 22-12.3",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0)]
  }), void 0);
}

export default SvgConfetti;